export default pagination => (
  pagination.offset !== 0
    ? pagination.offset + pagination.limit
    : pagination.limit
);
